/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-correct': {
    width: 11,
    height: 11,
    viewBox: '0 0 11 11',
    data: '<path pid="0" d="M9.634 1.197a.497.497 0 0 1 .793.592l-.054.072-6.348 7.076a.497.497 0 0 1-.633.089L3.32 8.97.661 6.536a.497.497 0 0 1 .6-.787l.071.054L3.62 7.9l6.014-6.702z" _fill="#008D5E"/>'
  }
})
